import React from 'react';
import './App.css';
import Amplify from 'aws-amplify';

import Event from './events'
import LandingPage from './landing'
import { ThankYou, EventPassed } from './staticPages';

// import logo from './imgs/icon-48x48.png'
import logo from './imgs/ey_logo_2025_orig.png'
import { Space, Typography, Divider } from 'antd';
import { Router } from "@reach/router"
import awsconfig from './aws-exports';
import ConfirmEvent from './confirmAttendance';
Amplify.configure(awsconfig);

const NotFound = () => <p>Sorry, nothing here</p>

function App() {
  // console.log('app')
  return (
    <Router>
      <NotFound default />
      <AppContent path="/" >
        <LandingPage path="/" />
        <Event path="/events/:eventID" />
        <ThankYou path="/thanks/:msg/:eventName" />
        <EventPassed path="/events/pastDeadline/:eventName" />
        <ConfirmEvent path="/confirm/:talentEventID" />
      </AppContent>

    </Router >
  );
}


const AppContent = (props) => {

  return (
    // min-height 100vh - rollout top to bottom
    <div className="site-layout" width="50px">
      {/* <div style={{ display: 'flex', minHeight: '100vh', minWidth: '100vw', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'column' }}> */}
      <div className='form-container'>
        {props.children}

      </div>

      {/* Footer */}
      <div style={{ textAlign: 'center', bottom: 0, padding: 25, marginTop: 15 }}>
        <Space split={<Divider type="vertical" />}>
          <span>
            <img src={logo} alt="eylogo" height={40} />
          </span>
          <span>Powered by <a href="https://soulution.cz/" rel="noreferrer" target="_blank">Soulution</a> ©{(new Date()).getFullYear()}</span>
          <Typography.Link href="https://www.ey.com/en_gl/privacy-statement" rel="noreferrer" target="_blank">Privacy and cookies</Typography.Link>
        </Space>


      </div>
    </div >
  )
};


export default App;
